module.exports = __webpack_public_path__ + "9d3581b54ec87a52b93b8510092c56b9.svg";